<!--
 * @Description: 
 * @Author: git config user.name
 * @Date: 2024-07-10 10:22:08
 * @LastEditors: git config user.name
 * @LastEditTime: 2024-07-12 09:03:04
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\platform-services\components\addDialog.vue
-->
<template>
  <el-dialog :visible.sync="visible" class="primary-dialog" width="1000px" :title="title" :close-on-click-modal="false"
    @closed="handleClosed" center>
    <div v-if="visible">
      <div class="color-red">
        保存后仅对未开通和续费包年服务生效，不影响已购服务内容
      </div>
      <div class="mt20">
        <!-- class="overflow-y border-bottom no-bottm-border text-style" -->
        <el-form ref="infoForm" :model="infoForm" label-width="130px" :rules="infoRules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="包年费用（元）" prop="money">
                <el-input v-model="infoForm.money" class="blue-color" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用业务" prop="applyBus">
                <el-select v-model="infoForm.applyBus" placeholder="请选择" clearable>
                  <el-option v-for="(m, n) in yyyw" :key="'应用业务' + n" :label="m.sname" :value="m.value">
                  </el-option>
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="是否上架" prop="isHit">
                <el-radio v-model="infoForm.isHit" :label="1">上架</el-radio>
                <el-radio v-model="infoForm.isHit" :label="0">下架</el-radio>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效时间" prop="effectDate" v-if="infoForm.isHit == 1">
                <el-date-picker v-model="infoForm.effectDate" type="datetime" placeholder="请选择" clearable
                  value-format="yyyy-MM-dd HH:mm:ss" class="sp-date-picker"></el-date-picker>

              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="mt10">
        <div>享受权益：</div>
        <el-table ref="xTable" highlight-current-row :data="tableData" min-height="230px" class="mt10" border>
          <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
          <el-table-column prop="rightsType" label="权益类型" header-align="center" width="200"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="rightsContent" label="权益内容" header-align="center" min-width="200"
            show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer text-center">
      <el-button class="btn" size="small" @click="visible = false">取 消</el-button>
      <el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" @click="doSave">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { selectServiceFeeRights, saveServiceFee } from "api/modules/templateConfiguration";
export default {
  data() {
    return {
      visible: false,
      btnLoading: false,
      title: "平台技术服务费（包年）配置",
      infoForm: {
        money: null, // 包年费用
        applyBus: "", // 应用业务
        isHit: 0, // 是否上架 默认下架
        effectDate: "", // 生效时间
      },
      infoRules: {
        money: [{ required: true, message: "请输入包年费用", trigger: "blur" }],
        applyBus: [{ required: true, message: "请选择应用业务", trigger: "change" }],
        isHit: [{ required: true, message: "请选择是否上架", trigger: "change" }],
        effectDate: [{ required: true, message: "请选择生效时间", trigger: "change" }],

      },
      tableData: [],
    };
  },
  methods: {
    // 初始化数据
    initData() {

      // 清空数据
      this.tableData = [];
      this.getDetail();
    },
    //查看权益
    getDetail() {
      selectServiceFeeRights({})
        .then((res) => {
          this.tableData = res.data.serviceRights;
          // 数据回显
          Object.keys(this.infoForm).forEach((key) => {
            this.infoForm[key] = res.data[key]

          }
          );
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    doSave() {
      this.btnLoading = true;
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.infoForm,
          };

          saveServiceFee(params)
            .then((res) => {
              console.log(res);
              this.btnLoading = false;
              this.$message.success("操作成功");
              this.visible = false;
              this.$emit("change");
              this.$emit("update:isAdd", false);
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        } else {
          this.$message.warning('有必填项未填，请填写')
          this.btnLoading = false
          return false

        }
      });


    },

    // 关闭弹窗
    handleClosed() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.visible = false;
      this.$emit("change");
      this.$emit("update:isAdd", false);
    },
  },
  computed: {
    ...mapState("user", {
      userInfo: (state) => state.userInfo,
    }),
    ...mapState('dict', {
      yyyw: state => state.yyyw, // 学历

    }),
  },
};
</script>

<style scoped lang="less">
.color-red {
  color: red;
}
</style>